import HomeScene from "../../scenes/Landing";
export default HomeScene;
